
<template>
  <layout class="support" :useBanner="false">

    <!-- banner页面 -->
    <Banner :data="info.banner" />

    <!-- 开发教程 && 技术文档 -->
    <Tutorial :data="info.tutorial" />

    <!-- 培训视频 -->
    <Train :data="info.train" />

    <!-- 新闻资讯 -->
    <News :data="info.news" />

    <!-- 书籍 -->
    <Book :data="info.books" />
  </layout>
</template>

<script>
import layout from '@/components/layout/layout'
import Banner from './Banner'
import Tutorial from './Tutorial'
import Train from './Train'
import News from './News'
import Book from './Book'

export default {
  components: {
    layout,
    Banner,
    Tutorial,
    Train,
    News,
    Book
  },
  data () {
    return {

    }
  },
  computed: {
    info () {
      return this.$t('ai')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
